import React, { useState, useEffect,useRef } from "react";
import axios from 'axios';
import {DrawingText,isNull,DownloadImageFile,ChangeNumberFormat} from "../../../components/common/Common";


const CertificationCanvas = ({varShowCanvas,varDetailInfo,setDetailInfo,varLevelList,varSearchStatus,setSearchStatus,ToggleCertificationCanvas,setCertificationFile}) => {
  const canvasRef = useRef(null);
  const [varCanvasSize,setCanvasSize] = useState({});
  const [varCanvasImage,setCanvasImage] = useState(null);

  //캔버스에 이미지 호출
  const ShowImage = () => {
    //배경이미지 호출
    const backData = varLevelList.find(el=>el.vl_idx===varDetailInfo.vl_idx);
    let fileName = backData.vl_file;
    if(varDetailInfo.ce_lang === 2) fileName = backData.vl_efile;

    const contents = canvasRef.current.getContext('2d');

    const img = new Image();
    img.src = `${process.env.REACT_APP_HOST}/certificate/${fileName}`;
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      contents.drawImage(img, 0, 0, canvasRef.current.width, canvasRef.current.height);

      //글자넣기
      let issueNum = varDetailInfo.ce_code;
      let issueDate = "20"+varDetailInfo.ce_idate;
      
      let sname = varDetailInfo.ch_name;
      let scompany = varDetailInfo.bh_company;
      let sbirthArray = varDetailInfo.ch_birthday.split('.');
      let sbirthday = '20'+sbirthArray[0]+'.'+sbirthArray[1]+'.'+sbirthArray[2];

      if(varDetailInfo.ce_lang===1) { //국문
        const slevel = `${varDetailInfo.vl_name} (${varDetailInfo.vl_terms}년수료)`;

        let info1 = {text:issueNum,x:100,y:75,fsize:10,textAlign:'left'}; DrawingText(contents,info1);
        let info2 = {text:issueDate,x:110,y:95,fsize:10,textAlign:'left'}; DrawingText(contents,info2);
        let info3 = {text:slevel,x:325,y:315,fsize:15,textAlign:'left'}; DrawingText(contents,info3);
        let info4 = {text:sname+' ( '+sbirthday+' )',x:325,y:345,fsize:15,textAlign:'left'}; DrawingText(contents,info4);
        let info5 = {text:scompany,x:490,y:370,fsize:12,textAlign:'right'}; DrawingText(contents,info5);
      } else {  //영문
        const slevel = `${varDetailInfo.vl_name} (${ChangeNumberFormat(varDetailInfo.vl_terms)} year)`;
        sname = isNull(varDetailInfo.ch_ename)?"":varDetailInfo.ch_ename;
        scompany = varDetailInfo.bh_ecompany;
        let info1 = {text:issueNum,x:100,y:123,fsize:14,textAlign:'left'}; DrawingText(contents,info1);
        let info2 = {text:issueDate,x:115,y:151,fsize:14,textAlign:'left'}; DrawingText(contents,info2);
        let info3 = {text:slevel,x:490,y:345,fsize:24,textAlign:'left'}; DrawingText(contents,info3);
        let info4 = {text:sname+' ( '+sbirthday+' / '+scompany+' )',x:540,y:425,fsize:20,textAlign:'center'}; DrawingText(contents,info4);
      }
      let images = canvasRef.current.toDataURL();
      setCanvasImage(images);
    };
  }

  useEffect(() => {
    if(varShowCanvas) {
      if(varDetailInfo.ce_lang === 1) {
        setCanvasSize({totalx:620,totaly:850,width:560,height:700});
      } else {
        setCanvasSize({totalx:1160,totaly:860,width:1100,height:720});
      }
      if(varDetailInfo.ce_status === 1) ShowImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varShowCanvas]);

  //발급상태 변경
  const onUploadCertificationHandler = async(e) => {
    //수료증 저장
    if(varDetailInfo.ce_status === 1) {
      var blobBin = atob(varCanvasImage.split(',')[1]);	// base64 데이터 디코딩
      var array = [];
      for (var i = 0; i < blobBin.length; i++) {
          array.push(blobBin.charCodeAt(i));
      }
      var file = new Blob([new Uint8Array(array)], {type: 'image/png'});	// Blob 생성
      console.log(file);

      var formData = new FormData();	// formData 생성
      formData.append("certificate", file);

      await axios.post(`${process.env.REACT_APP_HOST}/certificate`,formData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const fileName = datas.fileName;

          setCertificationFile(fileName);
          setSearchStatus(2);
          setDetailInfo({...varDetailInfo,ce_issue:1,ce_file:fileName,ce_status:2});

        } else {
          alert('수료증 생성에 실패하였습니다.');
        }
      });
    }
  }

  //다운로드
  const onDownloadCertificationHandler = (e) => {
    const files = `${process.env.REACT_APP_HOST}/certificate/${varDetailInfo.ce_file}`;
    DownloadImageFile(files,varDetailInfo.ce_code+".png");
  }

  return (
    <div className={varShowCanvas?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:`${varCanvasSize.totalx}px`,height:`${varCanvasSize.totaly}px`}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>수료증</div>
          <div className="layer__pop__close" onClick={()=>ToggleCertificationCanvas(false)}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px",display:"flex",justifyContent:"space-around"}}> 
          <div className="main-box" style={{width:`${varCanvasSize.width}px`,height:`${varCanvasSize.height}px`}}>
            {varSearchStatus===0?null
            :varSearchStatus===2?
              <img src={`${process.env.REACT_APP_HOST}/certificate/${varDetailInfo.ce_file}`} style={{width:varCanvasSize.width,height:varCanvasSize.height}} alt=""/>
            :
              <canvas ref={canvasRef} width={varCanvasSize.width} height={varCanvasSize.height} style={{border:"solid 1px #eee"}}/>
            }
          </div>
        </div>
        <div className="btn-center">
          {varSearchStatus===1?null:<button onClick={e=>onDownloadCertificationHandler(e)} style={{width:"90px"}} className="btn">다운로드</button>}
          {varSearchStatus===2?null:<button onClick={e=>onUploadCertificationHandler(e)} style={{width:"90px"}} className="btn">저장</button>}
          <button onClick={()=>ToggleCertificationCanvas(false)} style={{width:"90px"}} className="btn line">닫기</button>
        </div>
      </div>
    </div> 
  )
}
export default CertificationCanvas;